import React from "react";
import "./tableStyle.css";
import TxnProfileEnum from "src/utils/txn-profile.enum";

const WithdrawalTable = ({ formFieldData }) => {
  const withdrawalTitles = Object.keys(formFieldData);

  // Calculate totals for each column
  const totals = withdrawalTitles.reduce(
    (acc, title) => {
      acc[0] += parseInt(formFieldData[title][0].user_input_value, 10) || 0; // Column 1
      acc[1] += parseInt(formFieldData[title][1].user_input_value, 10) || 0; // Column 2
      acc[2] += parseInt(formFieldData[title][2].user_input_value, 10) || 0; // Column 3
      return acc;
    },
    [0, 0, 0] // Initial totals for each column
  );

  return (
    <table className="transactionTable">
      <tr>
        <th className="headline">Particulars</th>
        <th className="headline">Number of Transactions (Monthly)</th>
        <th className="headline">Maximum Size (per transaction)</th>
        <th className="headline">Total Amount (monthly)</th>
      </tr>
      {withdrawalTitles.map((title, index) => (
        <tr key={index}>
          <td>{TxnProfileEnum[title]}</td>
          <td>{formFieldData[title][0].user_input_value}</td>
          <td>{formFieldData[title][1].user_input_value}</td>
          <td>{formFieldData[title][2].user_input_value}</td>
        </tr>
      ))}
      <tr>
        <td>
          <b>Total</b>
        </td>
        <td>
          <b>{totals[0]}</b>
        </td>
        <td>
          <b>{totals[1]}</b>
        </td>
        <td>
          <b>{totals[2]}</b>
        </td>
      </tr>
    </table>
  );
};

export default WithdrawalTable;
